// 环境配置
interface EnvironmentConfig {
  wsUrl: string
  apiBaseUrl: string
  isDevelopment: boolean
  isProduction: boolean
}

// 获取当前环境
const getEnvironment = (): 'development' | 'production' => {
  // 检查是否是开发环境
  if (import.meta.env.DEV) {
    return 'development'
  }
  
  // 检查是否是生产环境
  if (import.meta.env.PROD) {
    return 'production'
  }
  
  // 默认返回开发环境
  return 'development'
}

// 根据环境获取配置
const getConfig = (): EnvironmentConfig => {
  const env = getEnvironment()
  
  if (env === 'development') {
    return {
      wsUrl: 'ws://localhost:8000/ws/',
      apiBaseUrl: 'http://localhost:8000',
      isDevelopment: true,
      isProduction: false
    }
  } else {
    return {
      wsUrl: 'ws://cs.internal.dd2wm.cn/ws/',
      apiBaseUrl: 'https://cs.internal.dd2wm.cn',
      isDevelopment: false,
      isProduction: true
    }
  }
}

// 导出配置
export const config = getConfig()

// 导出环境检查函数
export const isDevelopment = () => config.isDevelopment
export const isProduction = () => config.isProduction

// 导出 WebSocket URL
export const getWebSocketUrl = () => config.wsUrl

// 导出 API 基础 URL
export const getApiBaseUrl = () => config.apiBaseUrl

// 调试信息
console.log('当前环境配置:', {
  environment: getEnvironment(),
  wsUrl: config.wsUrl,
  apiBaseUrl: config.apiBaseUrl,
  isDevelopment: config.isDevelopment,
  isProduction: config.isProduction
}) 